import { Box, Separator } from "@chakra-ui/react-v3";
import { NoteDisplay } from "../components/note-display";
import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { ProcedureRowData } from "../tables/procedure";

export type ProcedureSidePanelContentProps = {
  data: ProcedureRowData;
};

/**
 * Side panel content for procedure resources.
 * Shows procedure details, date performed, status, and optionally AI analysis.
 */
export function ProcedureSidePanelContent({ data }: ProcedureSidePanelContentProps) {
  const withNotes = data.diagnosticReports.filter(
    r => r.presentedForm?.length && r.presentedForm.length > 0
  );

  const allProcedures = "resources" in data.originalData ? data.originalData.resources : [];

  return (
    <SidePanelLayout
      title="Procedure"
      subtitle={data.procedure}
      metadata={`Date Performed: ${data.datePerformed}`}
    >
      <ResourceAnalysis />

      {/* Note Display Section */}
      {withNotes.length > 0 && (
        <>
          {withNotes.map(report => (
            <Box key={report.id}>
              <NoteDisplay resource={report} />
            </Box>
          ))}
          <Separator borderColor="border" />
        </>
      )}

      {/* Documents Section */}
      <DocumentsSection resources={allProcedures} resourceType="Procedure" />
    </SidePanelLayout>
  );
}
